(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsh-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(() => {
  const targets = [5,4,4,3,3,3,2];
  const classify = p => {
    const t = `${p.type} ${p.title} ${p.tags.join(' ')}`.toLowerCase();
    const c = p.collections;
    if (/\b(bottle|bottles|codd|ginger beer|cold cream|chemist)\b/.test(t) && !/genie/.test(t)) return 3;
    if (/opera glasses|binocular|camera|telescope|microscope/.test(t)) return 5;
    if (/\b(basket|baskets|sewing box|sewing boxes)\b/.test(t)) return 5;
    if (/wooden.*bowl|wood.*sculpture/.test(t)) return 6;
    if (/\b(chair|chairs|armchair|armchairs|sofa|cabinet|wardrobe|sideboard|daybed|day bed|bench|desk|table|lounge|settee|bookcase|stool|dresser|chest of drawers)\b/.test(t)) return 0;
    if (/jewell?ery|jewelry|brooch|necklace|cufflink|earring|bracelet|pendant|handbag|bag charm/.test(t) || c.includes('jewelry')) return 4;
    if (/pottery|ceramic|porcelain|stoneware|earthenware|sylvac|royal dux/.test(t)) return 2;
    if (c.includes('art-glass-1') || /glass|crystal/.test(t)) return 1;
    if (c.includes('ceramics')) return 2;
    if (c.includes('all-wall-art') || /painting|artwork|lithograph|sculpture|wall art/.test(t)) return 6;
    return 5;
  };
  const locations = p => {
    const stocked = p.locations.filter(x => x.available).map(x => /232 Fitzgerald/i.test(x.name) ? 'Northam Secondhand' : x.name);
    if (stocked.length) return [...new Set(stocked)];
    const tags = p.tags.join(' ').toLowerCase();
    if (p.collections.includes('toodyay-antiques') || tags.includes('toodyay')) return ['Toodyay Antiques'];
    if (tags.includes('northam secondhand')) return ['Northam Secondhand'];
    return [];
  };
  const select = (pool, limit=24, quotas=targets) => {
    const used = new Set();
    const groups = quotas.map((quota,category) => pool.filter(p=>p.category===category).slice(0,quota));
    for (const shop of ['toodyay','northam']) {
      if (!groups.flat().some(p=>p.stores.some(s=>s.toLowerCase().includes(shop)))) {
        const candidate = pool.find(p=>quotas[p.category]>0&&p.stores.some(s=>s.toLowerCase().includes(shop)));
        if (candidate) { const g=groups[candidate.category]; if(g.length>=quotas[candidate.category]) g.pop(); g.push(candidate); }
      }
    }
    const picked=[];
    for(let row=0;row<Math.max(...quotas);row++) for(const group of groups) {
      const p=group[row]; if(p&&!used.has(p.id)){picked.push(p);used.add(p.id);}
    }
    for(const p of pool){if(picked.length>=limit)break;if(!used.has(p.id)){picked.push(p);used.add(p.id);}}
    return picked.slice(0,limit);
  };
  const init = async root => {
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const labels=JSON.parse(root.querySelector('[data-arrivals-labels]').textContent);
    let candidates=JSON.parse(root.querySelector('[data-arrivals-candidates]').textContent).filter(Boolean);
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),3500);
    try {
      const url=new URL(`${root.dataset.root}collections/all`,location.origin);
      url.searchParams.set('sort_by','created-descending');url.searchParams.set('section_id','nsh-arrivals-feed');
      const result=await fetch(url,{signal:controller.signal});
      if(result.ok){const doc=new DOMParser().parseFromString(await result.text(),'text/html');const data=doc.querySelector('[data-nsh-arrivals-feed] script');if(data)candidates.push(...JSON.parse(data.textContent).filter(Boolean));}
    } catch {} finally {clearTimeout(timeout);}
    if(!root.isConnected)return;
    const pool=[...new Map(candidates.map(p=>[p.id,p])).values()].map(p=>({...p,category:classify(p),stores:locations(p)}));
    pool.sort((a,b)=>Number(b.created)-Number(a.created)||a.id-b.id);
    const newest=Number(pool[0]?.created||0);
    pool.sort((a,b)=>{
      const bandA=Math.floor((newest-Number(a.created))/2592000),bandB=Math.floor((newest-Number(b.created))/2592000);
      return bandA-bandB || Number(b.width>=600&&b.height>=600)-Number(a.width>=600&&a.height>=600) || Number(b.created)-Number(a.created);
    });
    const selected=select(pool), used=new Set(selected.map(p=>p.id));
    const worth=select(pool.filter(p=>!used.has(p.id)&&Number(p.created)<newest-2592000),4,[1,1,1,0,0,0,1]);
    worth.forEach(p=>used.add(p.id));
    const remaining=pool.filter(p=>!used.has(p.id));
    const grid=root.querySelector('[data-arrivals-grid]');
    const status=root.querySelector('[data-arrivals-status]');
    const more=root.querySelector('[data-arrivals-more]');
    const card=p=>{
      const li=document.createElement('li');li.className='nsh-arrivals__card';li.dataset.productId=p.id;li.dataset.category=String(p.category);
      const link=document.createElement('a');link.href=p.url;
      const photo=document.createElement('div');photo.className='nsh-arrivals__photo';
      const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.width=720;img.height=720;img.loading='lazy';img.decoding='async';photo.append(img);link.append(photo);
      const category=document.createElement('p');category.className='nsh-arrivals__category';category.textContent=labels.categories[p.category];link.append(category);
      const title=document.createElement('h3');title.textContent=p.title;link.append(title);
      const price=document.createElement('p');price.className='nsh-arrivals__price';price.textContent=(p.varies?labels.from+' ':'')+p.price;link.append(price);
      const place=document.createElement('span');place.className='nsh-arrivals__location';place.textContent=p.stores.join(' · ')||labels.enquire;link.append(place);li.append(link);return li;
    };
    const update=()=>{status.textContent=grid.children.length?labels.count.replace('[count]',grid.children.length):labels.empty;more.hidden=!remaining.length;};
    selected.forEach(p=>grid.append(card(p)));update();
    if(worth.length){root.querySelector('[data-arrivals-worth]').hidden=false;worth.forEach(p=>root.querySelector('[data-worth-grid]').append(card(p)));}
    more.addEventListener('click',()=>{
      const batch=select(remaining,12,[2,2,2,2,1,2,1]);const ids=new Set(batch.map(p=>p.id));
      const first=grid.children.length;batch.forEach(p=>grid.append(card(p)));
      for(let i=remaining.length-1;i>=0;i--)if(ids.has(remaining[i].id))remaining.splice(i,1);
      update();grid.children[first]?.querySelector('a').focus({preventScroll:true});
    });
  };
  document.querySelectorAll('[data-nsh-arrivals]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-nsh-arrivals]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
